import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

const items: EmploymentOccupation[] = [
  EmploymentOccupation.Employed,
  // Trabajo Temporal    Temporary Employment
  EmploymentOccupation.TemporaryEmployed,
  EmploymentOccupation.Unemployed,
  EmploymentOccupation.Student,
  EmploymentOccupation.Retired,
  EmploymentOccupation.SelfEmployed,
  EmploymentOccupation.Housewife,
  EmploymentOccupation.Official,
  EmploymentOccupation.MilitaryPersonnel,
  EmploymentOccupation.Other,
];

export const spainOccupationItems: OccupationMenuItem[] = items.map((it) => {
  return {
    label: "inputs.employment." + it.toLowerCase(),
    value: it,
  };
});
